<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div class="mx-3 mt-5 pt-4">
    <div class="row ka-search-Header">
        <div class="col d-flex align-items-center">
            Employee Call Recordings
        </div>
    </div>

    <div class="border p-2 ka-searchEmp-main mb-2">
        <form [formGroup]="employeeReportForm" class="px-2" (submit)="getEmployeeReport($event)">
            <div class="row">
                <div class="col customMultiSelect">
                    <label class="text-left ka-createEmp-label ka-float-left" for="region">
                        Region </label>
                    <ng-multiselect-dropdown [placeholder]="'Select Region'" [(ngModel)]="selectedRegion"
                        [settings]="multiSelectRegionDropdown" [data]="regionArray" formControlName="regionName"
                        (onSelect)="getSelectedRegion($event)" (onDeSelect)="onRegionDeSelect($event)"
                        (onSelectAll)="onRegionSelectAll($event)" (onDeSelectAll)="onRegionDeSelectAll($event)">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col customMultiSelect">
                    <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                        Branch </label>
                    <ng-multiselect-dropdown [placeholder]="'Select Branch'" [(ngModel)]="selectedBranch"
                        [settings]="multiDropdownSettings" [data]="branchMultiSelectItems" formControlName="branchName"
                        (onSelect)="onBranchItemSelect($event)" (onDeSelect)="onBranchItemDeSelect($event)"
                        (onSelectAll)="onBrachItemsSelectAll($event)" (onDeSelectAll)="onBranchDeSelectAll($event)">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col flexRows">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                            Employee Name </label>
                        <select id="name" formControlName="employeeName" class="form-select ka-dropdown-singleSelect1"
                            aria-label="Default select example">
                            <option class="select-option" name="empName" [ngValue]="null" ngDefaultControl selected>Select Employee
                            </option>
                            <option class="select-option" *ngFor="let empName of empNameMultiSelectItems"
                                [ngValue]="empName">{{empName.value}}</option>
                        </select>
                    </div>
                </div>
                <div class="col flexRows">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                            Profile ID </label>
                        <input type="text" formControlName="profileId" id="profileId" mdbInput class="form-control mb-2"
                            placeholder=" Enter Profile Id" (change)="onChange($event)">
                        <div *ngIf="employeeReportForm.controls['profileId'].errors && !employeeReportForm.controls['profileId'].pristine"
                            class="error-msg1">
                            <div [hidden]="!employeeReportForm.controls['profileId'].errors.pattern">
                                Enter Valid Profile ID!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                            Page Name</label>
                        <ng-multiselect-dropdown [placeholder]="'Select Page Name'" [settings]="multiDropdownSettings"
                            [data]="callPageArray" formControlName="page" class="ka-myProfile-multiSelect">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
                <div class="col flexRows">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                            From Date</label>
                        <input matInput [matDatepicker]="picker" [max]="maxDate" class="form-control ka-disabled"
                            placeholder="From Date" formControlName="fromRegistrationDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"
                            style="position: absolute;margin-left: 75%;margin-top: -50px;"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                    </div>
                </div>
                <div class="col">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="branch">
                            To Date</label>
                        <input matInput [matDatepicker]="picker1" [max]="maxDate" class="form-control ka-disabled"
                            placeholder="To Date" formControlName="toRegistrationDate">
                        <mat-datepicker-toggle matSuffix [for]="picker1"
                            style="position: absolute;margin-left: 75%;margin-top: -50px;"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>

                    </div>
                </div>
                <div class="col flexRows">
                    <div class="inputBox customMultiSelect">
                        <label class="text-left ka-float-left ka-createEmp-label" for="callStatus">
                            Call Status</label>
                        <select id="name" formControlName="callStatus" class="form-select ka-dropdown-singleSelect1"
                            aria-label="Default select example">
                            <option class="select-option" name="callStatus" [ngValue]="null" ngDefaultControl selected>Select Call Status
                            </option>
                            <option class="select-option" *ngFor="let status of CallStatusArray"
                                [ngValue]="status">{{status.value}}</option>
                        </select>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col d-flex align-items-center justify-content-center">
                    <button mdbBtn class="ka-myProfile-viewType"
                        mdbWavesEffect type="submit">Search</button>
                </div>
            </div>
        </form>
    </div>

    <app-grid *ngIf="displayValues.length > 0" [data]="displayValues" [defaultColumns]="headers" [formValue]="formValue"
        [type]="gridType2" [matchedHeaders]="matchedHeaders" [displayedColumns]="allheaders"
        [multiSelectItems]="totalFields" [selectedItems]="matchedHeaders" [profileTypeArray]="profileTypeArray"
        [scrollDown]="scrollDown" (playRecording)="playRecording($event)">
    </app-grid>

    <div class="lst-loadmore-container" *ngIf="displayValues.length >= 10 && !loadedAllData">
        <button (click)="loadMore()" class="lst-loadmore ka-myProfile-viewType ml-3 mt-2">Load More</button>
    </div>

    <div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="alert-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
                <span aria-hidden="true" class="alertClose" >&times;</span>
            </button>
            <div class="row text-left">
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">
                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <p class="mt-2 p-0">{{responseMessage}} </p>
                            <div class="action-buttons">
                                <button mdbBtn class="ka-myProfile-viewType"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>